module.exports = __webpack_public_path__ + "dist/media/icons.3cf410f9.svg";